<template>
	<div style="height: 100%;">
		<van-nav-bar left-arrow fixed title="积分兑换" :z-index="10" @click-left="$router.replace({'name':'home'})"></van-nav-bar>
		<div class="reveal">
			<div class="reveal-content">
				<!-- 头部 -->
				<div class="title">恭喜您兑换成功</div>
				<!-- 图片展示 -->
				<div>
					<img :src="order.coverImg" style="width: 130px;height: 130px;" />
					<!-- <img src="../../../assets/img/home/u68.png" style="width: 200px;height: 300px;" alt /> -->
				</div>
				<!-- 描述 -->
				<div class="des">{{order.goodsName}}</div>
				<div class="time">
					<span>礼品将于7天内发货，可在“</span>
					<router-link :to="{name:'shop-order-list'}">我的兑换</router-link>
					<span>”查看详情</span>
				</div>

				<!-- 炫耀一下 -->
				<van-button :to="{name:'home'}" class="sport" type="danger" size="small">我知道了</van-button>
			</div>
		</div>
	</div>

</template>

<script>
import * as GoodsApi from '@/api/goods';
// import { mapGetters } from 'vuex';
// import * as CustApi from '@/api/cust';
export default {
  data () {
    return {
      order: {},
      goods: {}
    };
  },
  beforeRouteEnter (to, form, next) {
    GoodsApi.getOrder(to.params.id)
      .then(data => {
        next(vm => {
          vm.setData(data);
        });
      })
      .catch(e => { });
  },
  beforeRouteUpdate (to, from, next) {
    GoodsApi.getOrder(to.params.id)
      .then(data => {
        this.setData(data);
      })
      .catch(e => { });
    next();
  },
  methods: {
    setData (data) {
      this.order = data;
      console.log(this.order);
    },
    xyClick () {
      console.log('触发了');
    }
  }
};
</script>

<style lang="less" scoped="">
.reveal {
  height: 100%;
  margin-top: 60px;
  text-align: center;
  background-color: #ffffff;
  overflow: hidden;
  // border: 1px solid #000000;

  .reveal-content {
    height: 100%;
    margin: 30px 20px;

    .title {
      font-size: 16px;
      font-weight: 700;
      color: #ff7f00;
      letter-spacing: 1px;
      margin-bottom: 20px;
    }
    .des {
      font-size: 14px;
      font-weight: 700;
      margin-top: 20px;
      // letter-spacing: 1px;
    }
    .time {
		font-size: 13px;
      margin-top: 5px;
      margin-bottom: 40px;
	  color: #333333;
      a {
        color: #1989fa;
      }
    }
    .sport {
      width: 280px;
      height: 40px;
      border-radius: 3px;
      background-color: #ff7f00;
	  border: none;
    }
  }
}
</style>
